import React, { Component } from 'react';
import { HashLink } from 'react-router-hash-link';
import { infoAssets } from '../App'

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        let { activeCategory, activeType, collectionAssets, typeAssets, mobileIsOpen, mobileToggle, setType, showInfo } = this.props;
        // console.log(this.props.location.pathname)
        return (<div className={mobileIsOpen ? 'App__sidebar active' : 'App__sidebar'} id={this.state.fixed} onMouseOver={this.sidebarOnHover} onMouseLeave={this.sidebarOutHover}>
            <div className='top-section'>
                <div className="column">
                    <div className='App__title' >
                        <h1><div className='tienda' onClick={() => { mobileToggle(this.props.history); }}>t</div></h1>
                    </div>
                    <h2 className='sidebar-title'>Design Store</h2>
                </div>

                <div className="expanded-detail">
                    <svg width="121" height="131" viewBox="0 0 121 131" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect class='m-hide' width="121" height="36" rx="18" fill="#FB3C5E" />
                        <rect class='m-hide' x="0.5" y="0.5" width="120" height="35" rx="17.5" stroke="#DE0A25" stroke-opacity="0.97" />
                        <path class='m-hide' d="M20.194 9.276H15.77V13.196H13.782V16.36H15.77V22.072C15.714 26.076 16.61 27 20.586 27H23.33V23.64H22.07C20.614 23.668 20.194 23.332 20.194 22.128V16.36H23.442V13.196H20.194V9.276ZM25.5829 27H30.0069V13.196H25.5829V27ZM25.5829 12.02H30.0069V8.324H25.5829V12.02ZM49.2414 20.98C49.1854 18.964 48.9054 17.648 48.1774 16.304C46.9174 13.924 44.3134 12.636 40.8414 12.636C35.6894 12.636 32.4414 15.576 32.4414 20.196C32.4414 22.24 33.1134 24.032 34.3734 25.32C35.8014 26.776 38.0974 27.56 41.0094 27.56C43.4454 27.56 45.3214 26.944 46.9174 25.628C48.0374 24.704 48.6254 23.892 49.0734 22.632H44.1734C43.6414 23.892 42.5774 24.48 40.8694 24.48C38.4894 24.48 36.9494 23.136 36.9214 20.98H49.2414ZM37.0614 18.236C37.4814 16.332 38.7414 15.38 40.7854 15.38C42.8294 15.38 44.0614 16.332 44.5094 18.236H37.0614ZM51.6907 27H56.1147V19.804C56.1147 17.452 57.5147 16.024 59.8107 16.024C60.7627 16.024 61.6307 16.332 62.2467 16.864C62.9467 17.48 63.2267 18.292 63.2267 19.692V27H67.6507V19.384C67.6507 16.864 67.3147 15.688 66.2507 14.568C65.1587 13.392 63.3947 12.72 61.4907 12.72C59.4747 12.72 58.0187 13.308 56.1147 14.876V13.196H51.6907V27ZM86.6363 8.324H82.2123V14.512C80.8403 13.28 79.3283 12.72 77.4803 12.72C73.2523 12.72 70.0883 15.884 70.0883 20.112C70.0883 24.312 73.2523 27.476 77.4803 27.476C79.3283 27.476 80.8123 26.916 82.2123 25.684V27H86.6363V8.324ZM78.5443 15.884C80.7843 15.884 82.5483 17.76 82.5483 20.168C82.5483 22.436 80.7283 24.312 78.5163 24.312C76.2763 24.312 74.4843 22.436 74.4843 20.084C74.4843 17.732 76.2763 15.884 78.5443 15.884ZM94.7617 17.648C94.9017 16.024 95.8537 15.38 98.0937 15.38C100.194 15.38 101.426 16.024 101.426 17.116C101.426 18.04 100.81 18.264 96.8057 18.6C93.0537 18.936 92.2137 19.104 91.2057 19.636C89.8897 20.364 89.1617 21.568 89.1617 22.996C89.1617 24.2 89.6377 25.264 90.5617 26.104C91.6257 27.056 93.3057 27.56 95.4617 27.56C98.2057 27.56 99.8857 26.944 101.51 25.348C101.566 26.244 101.594 26.44 101.79 27H106.158C105.878 26.412 105.85 26.328 105.85 25.348V17.872C105.85 16.276 105.43 15.016 104.646 14.316C103.47 13.252 101.202 12.636 98.4017 12.636C95.4897 12.636 93.0257 13.308 91.7377 14.456C90.9257 15.184 90.5337 16.08 90.2817 17.648H94.7617ZM101.51 21.316C101.51 22.212 101.062 22.996 100.166 23.612C99.0737 24.368 97.7297 24.816 96.4977 24.816C95.0417 24.816 93.9217 23.976 93.9217 22.912C93.9217 22.352 94.2577 21.82 94.7617 21.596C95.2937 21.372 95.8257 21.288 97.7297 21.12C99.7457 20.924 100.222 20.812 101.51 20.364V21.316Z" fill="#DD001C" />
                        <path d="M61 53H63V61H61V53Z" fill="#D81931" />
                        <path d="M58 64C58 61.7909 59.7909 60 62 60C64.2091 60 66 61.7909 66 64V68H58V64Z" fill="#FB3C5E" />
                        <path d="M58 64C58 61.7909 59.7909 60 62 60C64.2091 60 66 61.7909 66 64V68H58V64Z" stroke="#5A5B8D" />
                        <path d="M54 71C54 68.7909 55.7909 67 58 67H66C68.2091 67 70 68.7909 70 71V75H54V71Z" fill="#FB3C5E" />
                        <path d="M54 71C54 68.7909 55.7909 67 58 67H66C68.2091 67 70 68.7909 70 71V75H54V71Z" stroke="#5A5B8D" />
                        <path d="M6 93C6 90.2386 8.23858 88 11 88H37C39.7614 88 42 90.2386 42 93V131H6V93Z" fill="#FB3C5E" />
                        <path d="M6 93C6 90.2386 8.23858 88 11 88H37C39.7614 88 42 90.2386 42 93V131H6V93Z" stroke="#5A5B8D" />
                        <path d="M82 91C82 88.2386 84.2386 86 87 86H108C110.761 86 113 88.2386 113 91V131H82V91Z" fill="#FB3C5E" />
                        <path d="M82 91C82 88.2386 84.2386 86 87 86H108C110.761 86 113 88.2386 113 91V131H82V91Z" stroke="#5A5B8D" />
                        <path d="M46 80C46 77.2386 48.2386 75 51 75H73C75.7614 75 78 77.2386 78 80V131H46V80Z" fill="#FB3C5E" />
                        <path d="M46 80C46 77.2386 48.2386 75 51 75H73C75.7614 75 78 77.2386 78 80V131H46V80Z" stroke="#5A5B8D" />
                        <circle cx="62" cy="52" r="2" fill="#FB3C5E" />
                        <circle cx="62" cy="52" r="2" stroke="#DB093B" />
                        <rect x="21" y="94" width="6" height="34" rx="1" fill="#DB093B" />
                        <rect x="21" y="94" width="6" height="34" rx="1" stroke="#275890" />
                        <rect x="11" y="94" width="6" height="34" rx="1" fill="#DB093B" />
                        <rect x="11" y="94" width="6" height="34" rx="1" stroke="#275890" />
                        <rect x="52" y="94" width="8" height="8" rx="1" fill="#DB093B" />
                        <rect x="52" y="94" width="8" height="8" rx="1" stroke="#275890" />
                        <rect x="52" y="81" width="8" height="8" rx="1" fill="#DB093B" />
                        <rect x="52" y="81" width="8" height="8" rx="1" stroke="#275890" />
                        <rect x="87" y="108" width="21" height="4" rx="1" fill="#DB093B" />
                        <rect x="87" y="108" width="21" height="4" rx="1" stroke="#275890" />
                        <rect x="87" y="116" width="21" height="4" rx="1" fill="#DB093B" />
                        <rect x="87" y="116" width="21" height="4" rx="1" stroke="#275890" />
                        <rect x="87" y="124" width="21" height="4" rx="1" fill="#DB093B" />
                        <rect x="87" y="124" width="21" height="4" rx="1" stroke="#275890" />
                        <rect x="87" y="100" width="21" height="4" rx="1" fill="#DB093B" />
                        <rect x="87" y="100" width="21" height="4" rx="1" stroke="#275890" />
                        <rect x="87" y="92" width="21" height="4" rx="1" fill="#DB093B" />
                        <rect x="87" y="92" width="21" height="4" rx="1" stroke="#275890" />
                        <rect x="52" y="107" width="8" height="8" rx="1" fill="#DB093B" />
                        <rect x="52" y="107" width="8" height="8" rx="1" stroke="#275890" />
                        <rect x="52" y="120" width="8" height="8" rx="1" fill="#DB093B" />
                        <rect x="52" y="120" width="8" height="8" rx="1" stroke="#275890" />
                        <rect x="31" y="94" width="6" height="34" rx="1" fill="#DB093B" />
                        <rect x="31" y="94" width="6" height="34" rx="1" stroke="#275890" />
                        <rect x="64" y="94" width="8" height="8" rx="1" fill="#DB093B" />
                        <rect x="64" y="94" width="8" height="8" rx="1" stroke="#275890" />
                        <rect x="64" y="81" width="8" height="8" rx="1" fill="#DB093B" />
                        <rect x="64" y="81" width="8" height="8" rx="1" stroke="#275890" />
                        <rect x="64" y="107" width="8" height="8" rx="1" fill="#DB093B" />
                        <rect x="64" y="107" width="8" height="8" rx="1" stroke="#275890" />
                        <rect x="64" y="120" width="8" height="8" rx="1" fill="#DB093B" />
                        <rect x="64" y="120" width="8" height="8" rx="1" stroke="#275890" />
                    </svg>


                </div>
            </div>
            <div className='middle-section collection'>
                <div className="column">
                    <h4 className='sidebar-title light'>Collection</h4>
                    <div className='active-collection'>
                        <img src={collectionAssets[activeCategory].image} alt=""/>
                        <h5 className='sidebar-title pill'>{collectionAssets[activeCategory].title}</h5>
                    </div>
                </div>
                <div className='expanded-detail'>
                    {collectionAssets.map((collection, index) => (
                        <HashLink to={(index === 0) ? '/#all' : '/collection/' + collection.handle}>
                            <div key={index} className='category-option'>
                                {collection.title}
                            </div>
                        </HashLink>
                    ))}
                </div>

            </div>
            <div className='middle-section grow'>
                <div className="column">
                    <h4 className='sidebar-title light'>Category</h4>
                    <div className='active-category'>
                        <img src={typeAssets[activeType] ? typeAssets[activeType].image : typeAssets[0].image} alt="" />
                        <h5 className='sidebar-title pill'>{typeAssets[activeType] ? typeAssets[activeType].title : typeAssets[0].title}</h5>
                    </div>
                </div>
                <div className='expanded-detail'>
                    {typeAssets.map((type, index) => {
                        if (index !== 0 ){
                        if (!this.props.location.pathname.includes('/products/')) {
                        return (<div key={index} className='category-option a' onClick={() => { setType(type.tag) }}>
                            {type.title}
                        </div>)} else {
                            return (<HashLink to={'/#'+type.title.toLowerCase()} className='category-option a'>
                                {type.title}
                            </HashLink>)
                        }
                        }
                        return false
                    })}
                </div>
                <div className='type-select'>

                </div>
            </div>
            <div className='image-section grow'>
                <img src='/img/sample-hero.png' alt="" />
                <div className='cover'></div>
            </div>
            {showInfo && (
                <div className='info-section grow'>
                    <div className='details'>
                        <span className='blue-color'>Last Updated</span>
                        <span className='white-glow'>Jan 5th, 2030</span>
                    </div>
                    <img src='/img/dark-sight.svg' className='expanded-detail' alt="" />
                </div>
            )}

            <div className='questions-section'>
                <a href='mailto:hello@tienda.nyc'>Questions?</a>
                <div className='expanded-detail'>
                    2:42pm 52º
              </div>
            </div>
            <div className='bottom-section'>
                <div className='column'>
                    <img className='sun-image' src='/img/sight-large.png' alt="" />
                    <div className='icon-links'>
                        <a href='https://www.instagram.com/tiendabysight/' target='_blank' rel='noreferrer'>
                            <img src='/img/insta.png' alt="Instagram icon"/>
                        </a>
                        <a href='https://twitter.com/sightnyc/' target='_blank' rel='noreferrer'>
                            <img src='/img/twitter.png' alt="Instagram icon" />
                        </a>
                        <img src='/img/help.png' alt="Instagram icon" />
                    </div>
                </div>
                <div className='expanded-detail'>
                    {infoAssets.map((info, index) => (
                        <a key={'info-'+index} href={info.link ? info.link : '#'} className='info-option' onClick={info.link ? () => {} : () => {this.props.openModal(index)}}>
                            {info.title}
                        </a>
                    ))}
                </div>
            </div>
        </div>
        );
    }
}

export default Sidebar;
